var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-group" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.categorySearch,
            expression: "categorySearch",
          },
        ],
        staticClass: "custom-select",
        attrs: {
          disabled: _vm.$store.state.loadCategoryStatus !== "completed",
        },
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.categorySearch = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            _vm.updateCategoryFilter,
          ],
        },
      },
      [
        _c(
          "option",
          { attrs: { value: "", disabled: "", selected: "" } },
          [
            _vm.$store.state.loadCategoryStatus !== "completed"
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("label.loading_categories")) +
                      "\n            "
                  ),
                ]
              : [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("label.select_category_filter")) +
                      "\n            "
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _vm._l(_vm.categories, function (category) {
          return _c(
            "option",
            { domProps: { value: category.id } },
            [
              _vm._l(Array(category.level), function (level) {
                return [_vm._v("——")]
              }),
              _vm._v("\n            " + _vm._s(category.name) + "\n        "),
            ],
            2
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          class: {
            "btn-secondary": this.$store.state.categoryId === "",
            "btn-danger": this.$store.state.categoryId !== "",
          },
          attrs: {
            type: "button",
            disabled: this.$store.state.categoryId === "",
          },
          on: { click: _vm.reset },
        },
        [_c("i", { staticClass: "fa fa-close" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }